import axios from 'axios';
import BaseAPI from './base/base-api';

class CriteriaSetupAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'criteriasetup';
}

export default new CriteriaSetupAPI();